"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// there is no Event class in nodejs
// for compilation purposes we need to polyfill it
if (!process.browser) {
    if (!('Event' in globalThis)) {
        Object.assign(globalThis, {
            Event: function EventPoly(type) {
                this.type = type;
            },
        });
    }
}
//# sourceMappingURL=event.js.map